export const stringUtil = {
  prepareDangerousHTML: (text) =>
    text.trim().replace(/<script[^>]*>([\s\S]*?)<\/script>/gi, ""),
};
